import {useEffect} from 'react';

const APP_TITLE = 'BirdMap Explorer';

export function buildPageTitle(...parts: Array<string | null | undefined>) {
    const filteredParts = parts
        .map(part => part?.trim())
        .filter((part): part is string => Boolean(part));

    if (!filteredParts.length) {
        return APP_TITLE;
    }

    return [...filteredParts, APP_TITLE].join(' | ');
}

export function usePageTitle(...parts: Array<string | null | undefined>) {
    const title = buildPageTitle(...parts);

    useEffect(() => {
        document.title = title;
    }, [title]);
}
